import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import "./styles/tokens.css";
import "./styles/app.css";
import "./styles/atelier.css";
import "./styles/fins.css";

const racine = document.getElementById("root");
if (!racine) throw new Error("#root introuvable dans index.html");

createRoot(racine).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
